import { combineReducers } from 'redux'

//reducers
import { home } from './home'
import { configuration } from './configuration'
import { ReduxRegisterPoint } from './registerPoint'
import { ReduxPointFlow } from './pointFlow'
import { token } from './token'
import { codigoliberacao } from './codigoliberacao'


//reducers sagas
import { companies } from './endpoints/companies'
import { loginToConfiguration } from './endpoints/loginToConfiguration'
import { client } from './endpoints/clients'
import { unit } from './endpoints/units'
import { loginAdm } from './endpoints/loginAdm'
import { registerPoint } from './endpoints/registerPoint'
import { loginUser } from './endpoints/loginUser'
import { findDataByRe } from './endpoints/findDataByRE'
import { registrarPontoComLogin } from './endpoints/registrarPontoComLogin'
import { atualizarSenha } from './endpoints/atualizarSenha'
import { salvarConfiguracoesComLogin } from './endpoints/salvarConfiguracoesComLogin'
import { checkGeo } from './endpoints/checkGeo'
import { validateUser } from './endpoints/userValidation'
import { baterPonto } from './endpoints/baterPonto'
import { findCoordsByUnit } from './endpoints/findCoordsByUnit'
import { currentTime } from './endpoints/currentTime'
import { registrarinfo } from './endpoints/registrarinfo'
import { protocol } from './endpoints/protocols'
import { protocolDate } from './endpoints/protocolsByDate'
import { sendSms } from './endpoints/sendSms'
import { validarDispositivo } from './endpoints/validarDispositivo'
import { createDispositivo } from './endpoints/createDispositivo'
import { habilitarDispositivo } from './endpoints/habilitarDispositivo'
import { getProtocolsByMonth } from './endpoints/getProtocolsByMonth'

import { appConfig } from './appConfig'





const reducers = combineReducers({
  home: home,
  configuration: configuration,
  registerPoint: ReduxRegisterPoint,
  pointFlow: ReduxPointFlow,
  token: token,
  codigoliberacao: codigoliberacao,
  

  sagaCompanies: companies,
  sagaClients : client,
  sagaUnits: unit,
  sagaLoginAdm: loginAdm,
  sagaRegisterPoint: registerPoint,
  sagaLoginToConfiguration: loginToConfiguration,
  sagaLoginUser: loginUser,
  sagaFindDataByRe: findDataByRe,
  sagaRegistrarPontoComLogin: registrarPontoComLogin,
  sagaAtualizarSenha: atualizarSenha,
  sagaSalvarConfiguracoesComLogin: salvarConfiguracoesComLogin,
  sagaCheckGeo: checkGeo,
  sagaValidateUser: validateUser,
  sagaBaterPonto: baterPonto,
  sagaFindCoordsByUnit: findCoordsByUnit, 
  sagaCurrentTime: currentTime,
  sagaRegistrarInfo: registrarinfo,
  sagaProtocols: protocol,
  sagaProtocolDate: protocolDate,
  sagaSendSms: sendSms,
  sagaValidarDispositivo: validarDispositivo,
  sagaCreateDispositivo: createDispositivo,
  sagaHabilitarDispositivo: habilitarDispositivo,
  getProtocolsByMonth: getProtocolsByMonth,
  appConfig: appConfig
})

export default reducers